import { render } from "./SpaceBackground.vue?vue&type=template&id=55c2b458&scoped=true"
import script from "./SpaceBackground.vue?vue&type=script&lang=js"
export * from "./SpaceBackground.vue?vue&type=script&lang=js"

import "./SpaceBackground.vue?vue&type=style&index=0&id=55c2b458&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c2b458"]])

export default __exports__